module.exports = __webpack_public_path__ + "components/flag/static/square/th-57169b96faade814100652273fa47d3e.svg";